module.exports = __webpack_public_path__ + "img/back_100.77c84bcd.png";